/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ArrowUpDownIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="arrow-up-down"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M7 17L7 4.5M7 4.5L11.419 8.919M7 4.5L2.581 8.919" data-tinysvg-shape="arrow" data-tinysvg-arrow="7 17 7 4.5 50" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17 7L17 19.5M17 19.5L12.581 15.081M17 19.5L21.419 15.081" data-tinysvg-shape="arrow" data-tinysvg-arrow="17 7 17 19.5 50" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
